export const SITE = {
  name: 'BrowserKit',
  origin: 'https://browserkit-tools.pages.dev',
} as const

export type CoreLocale = 'en' | 'zh-CN' | 'zh-TW'
export type Locale = CoreLocale | 'es' | 'de' | 'ja' | 'fr' | 'pt-BR'
export const locales: Locale[] = ['en', 'zh-CN', 'zh-TW', 'es', 'de', 'ja', 'fr', 'pt-BR']
export const localeLabels: Record<Locale, string> = { en: 'English', 'zh-CN': '简体中文', 'zh-TW': '繁體中文', es: 'Español', de: 'Deutsch', ja: '日本語', fr: 'Français', 'pt-BR': 'Português (Brasil)' }
export const localePrefixes: Record<Locale, string> = { en: '', 'zh-CN': '/zh-cn', 'zh-TW': '/zh-tw', es: '/es', de: '/de', ja: '/ja', fr: '/fr', 'pt-BR': '/pt-br' }

export function localePath(locale: Locale, path = '/') {
  const normalizedPath = path === '/' ? '/' : `${path.replace(/\/+$/, '')}/`
  if (locale === 'en') return normalizedPath
  return path === '/' ? `${localePrefixes[locale]}/` : `${localePrefixes[locale]}${normalizedPath}`
}
